'use client';

import { Brand } from '@/types/brand';
import { createContext, FC, PropsWithChildren } from 'react';

/*  This provider is used to expose values that would usually be set as NEXT_PUBLIC.
It's a workaround since we set the env variables in file via entrypoint.sh, but NEXT_PUBLIC 
variables are embedded directly in the code when doing next build. Therefore we instead 
pass them from server to client via server components. */

// ! WARNING: Only send PUBLIC values through here, don't expose any secret env variables
type PublicEnvVars = Pick<
  typeof process.env,
  | 'PUBLIC_FARO_URL'
  | 'PUBLIC_FARO_ENABLED'
  | 'PUBLIC_RUNTIME_ENV'
  | 'TEMP_METER_STATUS_USAGE_SITES_ENABLED'
  | 'NORWAY_HIDE_COST_DETAILS'
  | 'SWEDEN_HIDE_COST_DETAILS'
  | 'BOOKMARKS_ENABLED'
> & { brand?: Brand };

export const PublicEnvVarsContext = createContext<PublicEnvVars>({
  PUBLIC_FARO_ENABLED: undefined,
  PUBLIC_FARO_URL: '',
  PUBLIC_RUNTIME_ENV: undefined,
  TEMP_METER_STATUS_USAGE_SITES_ENABLED: undefined,
  NORWAY_HIDE_COST_DETAILS: undefined,
  SWEDEN_HIDE_COST_DETAILS: undefined,
  BOOKMARKS_ENABLED: undefined,
  brand: undefined,
});

type Props = PropsWithChildren<{ env: PublicEnvVars }>;

const PublicEnvVarsProvider: FC<Props> = ({ children, env }) => {
  return <PublicEnvVarsContext.Provider value={env}>{children}</PublicEnvVarsContext.Provider>;
};

export default PublicEnvVarsProvider;
